import { createSlice } from '@reduxjs/toolkit'
import { IStore } from 'helpers';

export const producerReducer = createSlice({
  name: 'producer store',
  initialState: {
    providerType: -1,
    modeSelected: '',
    providerInfo: {
      firstName: '',
      fullName: '',
      lastName: '',
      producerId: '',
      profilePicUrl: '',
    },
    structureFolders: [],
    hasDocument: false
  },
  reducers: {
    setProviderType: (state, action) => {
      state.providerType = action.payload
    },
    setMode: (state, action) => {
      state.modeSelected = action.payload
    },
    setProviderInfo: (state, action) => {
      state.providerInfo = action.payload
    },
    setHasDocument: (state, action) => {
      state.hasDocument = action.payload
    },
    setStructureFolders: (state, action) => {
      state.structureFolders = action.payload
    }
  }
})

export const { setProviderType, setMode, setProviderInfo, setStructureFolders } = producerReducer.actions

export const getProviderType = (state: IStore) => state.producer.providerType
export const getMode = (state: IStore) => state.producer.modeSelected
export const getProviderInfo = (state: IStore) => state.producer.providerInfo
export const getHasDocument = (state: IStore) => state.producer.hasDocument
export const getStructureFolders = (state: IStore) => state.producer.structureFolders;

export default producerReducer.reducer